import { useQuery } from 'react-query';

import { getUsers } from '../../services/user.service';

export const getUsersQueryKey = 'getUsers';
export const useUsersList = (params: Record<string, any>) => useQuery([getUsersQueryKey, params], () => getUsers(params)
  .then((result) => result.data), {
  refetchOnWindowFocus: false, retry: false, cacheTime: 0,
});
